import moment from "moment";

export default function(value, options) {
  !options && (options = { nullValue: "" });
  if (!value) return options.nullValue;
  let date = new moment(value);
  return date.format(options.dateFormat || "DD/MM/YYYY HH:mm");
}



// WEBPACK FOOTER //
// ./src/filters/dateFormatter.js